"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/focus-trap.ts
var _focustrap = require('@ariakit/react-core/focus-trap/focus-trap');
var _focustrapregion = require('@ariakit/react-core/focus-trap/focus-trap-region');




exports.FocusTrap = _focustrap.FocusTrap; exports.FocusTrapRegion = _focustrapregion.FocusTrapRegion;
